import request from '@/utils/request';
const base_path = '/upload';

/**
 * 图片上传
 * @param {FormData} data 数据结构
 */
export const uploadImagesApi = (data) => {
  return request({
    url: `${base_path}/images`,
    method: 'post',
    data,
  });
};
